module.exports = __webpack_public_path__ + "img/2.23163ef0.png";